exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kv-tab-panel {\n  width: 100%;\n  margin-top: 20px;\n}\n.kv-tab-panel .kv-tab-panel.is-scrollable {\n  height: 100%;\n  overflow-y: auto;\n}\n", ""]);

// exports
